export { LocaleSwitcher } from './locale-switcher';
